import React, { useState, useEffect } from 'react'
import { width } from '../../../../CustomComponents/DynamicCard/DynamicCardStyles'
import CustomTextInput from '../../../../CustomComponents/CustomtextInput'
import RightArrow from "../../../../../assets/images/RightArrow@2x.png"
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../../../CustomComponents/Loader'
import DynamicCard from '../../../../CustomComponents/DynamicCard'
import { withOidcSecure } from '@axa-fr/react-oidc'
import CustomDatePicker from '../../../../CustomComponents/CustomDateInput'
import { addLineBreaks, displayErrorMessage } from '../../../../../utils'
import logFirebaseEvents from '../../../../LogFirebaseEvents'
import CardHeading from '../../../../CustomComponents/CardHeading'
import { appTheme } from '../../../../../helpers/utils/Utils'

const AllocateDateCard = ({ cardHeader, cardFooter, onBack, onNext }) => {
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue); 
const appThemeData = appTheme(kudzuPlusTrue);

  const { t } = useTranslation();
  const navigate = useNavigate()
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [dateError, setDateError] = useState(null)
  const [isNext, setIsNext] = useState(false);

  const selectedDate = useSelector(state => state.allocateFund.TargetDate)
  const selectedStartdDate = useSelector(state => state.allocateFund.StartDate)
  const selectedEndDate = useSelector(state => state.allocateFund.EndDate)
  const styleForbuttons = "md:mr-[80px]"
  const selectedFrequencyValueDATA = useSelector((state) => state.selectedFrequencyValue);
  const { Code, DisplayText } = selectedFrequencyValueDATA;
  const [endDateErrorMsg, setEndDateErrorMsg] = useState("");
  const [targetDateErrorMsg, setTargetDateErrorMsg] = useState("");
  const [startDateErrorMsg, setStartDateErrorMsg] = useState("");

  const targetdate = useSelector((state) => state.savingGoals.date);
  const savingGoalTargetDate = useSelector((state) => state.savingGoals.targetDate);
  
  console.log("allocdate", targetdate)
  console.log("savingGoalTargetDate", savingGoalTargetDate)

  const handleBackClick = () => {
    logFirebaseEvents("Allocate_Fund", "Back_DateCard_Clicked", "Back_DateCard_Clicked","", "")
    onBack("AccountName")
  }
  const handleNextClick = () => {
    logFirebaseEvents("Allocate_Fund", "Next_DateCard_Clicked", "Next_DateCard_Clicked","", "")
     onNext("AllocateConfirmationCard"); 
  }

  const onDateChange = (date) => {
   

    const dateObj = new Date(date);
    const targetDateObj = targetdate ? new Date(targetdate) : null;
    const savingGoalTargetDateObj = savingGoalTargetDate ? new Date(savingGoalTargetDate) : null; 
    const comparisonDateObj = targetDateObj || savingGoalTargetDateObj;

    if (comparisonDateObj && dateObj > comparisonDateObj) {
      setTargetDateErrorMsg(`The start date must be on or before the Saving Goal target date (${comparisonDateObj.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric"
      })})`);
    } else {
      setTargetDateErrorMsg("");
    }

    // if (Code === "OT") {
    //   const formattedDate = new Date(Date.parse(date));
    //   const currentDate = new Date();
    //   currentDate.setHours(0, 0, 0, 0);
    //   if (formattedDate.setHours(0, 0, 0, 0) === currentDate.getTime()) {
    //     setTargetDateErrorMsg(""); 
    //   } else {
    //     setTargetDateErrorMsg(`The start date must be current only (${currentDate.toLocaleDateString("en-US", {
    //       year: "numeric",
    //       month: "short",
    //       day: "numeric"
    //     })})`);
    //     return; 
    //   }
    // }

    dispatch({ type: 'ALLOCATE_FUND', payload: { 'key': "TargetDate", 'value': date } })
  
  }

  const onStartDateChange = (date) => {

    const dateObj = new Date(date);
    const targetDateObj = targetdate ? new Date(targetdate) : null;
    const savingGoalTargetDateObj = savingGoalTargetDate ? new Date(savingGoalTargetDate) : null; 

    const comparisonDateObj = targetDateObj || savingGoalTargetDateObj;

    if (comparisonDateObj && dateObj > comparisonDateObj) {
      setStartDateErrorMsg(`The start date must be on or before the Saving Goal target date (${comparisonDateObj.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric"
      })})`);
    } else {
      setStartDateErrorMsg("");
    }
  

    dispatch({ type: 'ALLOCATE_FUND', payload: { 'key': "StartDate", 'value': date } });
    
    dispatch({ type: 'ALLOCATE_FUND', payload: { 'key': "EndDate", 'value': undefined } });
    setEndDateErrorMsg(""); 
  };
  
  

  const onEndDateChange = (date) => {
    const dateObj = new Date(date);
    const targetDateObj = targetdate ? new Date(targetdate) : null;
    const startDateObj = selectedStartdDate ? new Date(selectedStartdDate) : null;
    const savingGoalTargetDateObj = savingGoalTargetDate ? new Date(savingGoalTargetDate) : null; 
    const comparisonDateObj = targetDateObj || savingGoalTargetDateObj;

    if (comparisonDateObj && dateObj > comparisonDateObj) {
      setEndDateErrorMsg(`The end date must be on or before the Saving Goal target date (${comparisonDateObj.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric"
      })})`);
    } else if (startDateObj && dateObj < startDateObj) {
      setEndDateErrorMsg("End date cannot be earlier than start date");
    } else {
      setEndDateErrorMsg("");
    }

    dispatch({ type: 'ALLOCATE_FUND', payload: { 'key': "EndDate", 'value': date === undefined ? "": date } })
  }

 
  useEffect(() => {
    if (
      (selectedDate || selectedStartdDate) &&
      endDateErrorMsg === "" &&
      startDateErrorMsg === "" &&
      targetDateErrorMsg === ""
    ) {
      setDateError(null);
      setIsNext(true);
    } else {
      setIsNext(false);
    }
  }, [selectedDate, selectedStartdDate, endDateErrorMsg, startDateErrorMsg, targetDateErrorMsg]);
  
  

  const children = () => {
    return (
      <>
        {/* {cardHeader} */}

        <div
            className="sm:w-[auto] w-[257px] font-serif-pro font-[400] lg:text-[26px] md:text-[24px]
            sm:text-[22px] text-[25px] leading-[32px] sm:leading-[30px] md:leading-[36px] 
                text-[var(--text-clrs)] mt-6 sm:mx-0 mx-4"
            >
         {t("spending_alert_date_content1")} 
          <span className="text-[var(--text-body-clrs)] p-2">
            {Code == "OT"?
             (
              <>
              {addLineBreaks(t("Saving_Goal_Date_New"))}</>
            ):(
                <>{addLineBreaks(t("Allocate_Funds_Multiple_Dates"))}</>
            )}
                
            </span>
            {Code !== "OT" && (
          
             <div className='font-hanken-grotesk mt-5 font-[300] md:text-[18px] sm:text-[12px] text-[14px] sm:leading-[18px] md:leading-[24px] leading-[25px] text-[var(--modal-text-heading-clr)]'>{addLineBreaks(t('Allocate_Dates_Sub_Items'))}</div>
            )}
            
            {Code ===  "OT" && selectedDate === undefined && (
               <div className='font-hanken-grotesk mt-5 font-[300] md:text-[18px] sm:text-[12px] text-[14px] sm:leading-[18px] md:leading-[24px] leading-[25px] text-[var(--modal-text-heading-clr)]'>{addLineBreaks(t('Allocate_Funds_StartDate_Subtext'))}</div>
            )}
        </div>

        <div className='w-full flex justify-center'>
          <div className="sm:w-[78%] w-full md:mb-60">
            <div className='md:my-20 sm:my-16 mt-10 mb-[9rem] sm:mx-0 mx-4'>
              <div className='md:w-[80%] w-full flex flex-col-reverse gap-14 sm:flex-col justify-center'>
                
                {Code === "OT" ? (
                   <div>
                   <CustomDatePicker
                     selectedDate={selectedDate}
                     onDateChange={(date) => onDateChange(date)}
                     minDate={new Date(new Date().toUTCString().substr(0, 25))}
                     // minDate={new Date()}
                     // maxDate={''}
                     placeHolder={t('Month_Day_Year')}
                     disabledDates={[]}
                     title="Start Date"
                     hrbg='bg-dropdown-sky'
                   />
                     <div className='my-2 w-full'>
                    {targetDateErrorMsg !== ""  &&  displayErrorMessage(targetDateErrorMsg)}
                 </div>
                 </div>
                ):(
                  <>
                   <div className="md:mt-12 sm:mt-10 mt-12">
                  <CustomDatePicker
                    selectedDate={selectedStartdDate}
                    onDateChange={(date) => onStartDateChange(date)}
                    minDate={new Date(new Date().toUTCString().substr(0, 25))}
                    // minDate={new Date()}
                    // maxDate={''}
                    placeHolder={t('Month_Day_Year')}
                    disabledDates={[]}
                    title="start Date"
                    hrbg='bg-dropdown-sky'
                  />
                    <div className='my-2 w-full'>
                    {startDateErrorMsg !== ""  &&  displayErrorMessage(startDateErrorMsg)}
                 </div>
                </div>
                <div className="md:mt-12 sm:mt-10 mt-12">
                <CustomDatePicker
                  selectedDate={selectedEndDate}
                  onDateChange={(date) => onEndDateChange(date)}
                  minDate={new Date(new Date().toUTCString().substr(0, 25))}
                  // minDate={new Date()}
                  // maxDate={''}
                  placeHolder={t('Month_Day_Year')}
                  disabledDates={[]}
                  title="End Date (OPTIONAL)"
                  hrbg='bg-dropdown-sky'
                />
                 <div className='my-2 w-full'>
                    {endDateErrorMsg !== ""  &&  displayErrorMessage(endDateErrorMsg)}
                 </div>
              </div>
              </>
                )}
            
              </div>    
            </div>
          </div>
        </div>
        {cardFooter(handleBackClick, handleNextClick,'','', isNext,styleForbuttons)}
      </>
    )
  }
  return (
    <>
      <DynamicCard
        header={false}
        CardRadius={true}
        cardWidth={width.homeCard}
        isWhite={appThemeData.isWhiteBgForCard}
        isDarkForKudzu={appThemeData.isDarkBgForCard}
        backgroundColor={'--cardHeading-bg'} 
        HeaderContent={
            <>
                <CardHeading heading={t('Allocate_Funds')} />
            </>
        }
        HeaderRadius={true}
        footer={true}
         >
        {children()}
      </DynamicCard>
      {isLoading && <Loader />}
    </>

  )
}


export default withOidcSecure(AllocateDateCard)



